<template>
  <v-container fluid>
    <v-tabs color="primary accent-4" left v-model="tab">
      <v-tab key="0">{{ $t("generic.rules") }}</v-tab>
      <v-tab key="1">{{ $t("generic.substances") }}</v-tab>
    </v-tabs>
    <div class="ml-2 mt-2 text-subtitle-1">
      {{ tab === 0 ? $t("fav.infoTxt") : $t("fav.infoSubstance") }}
    </div>
    <!-- Rules -->
    <div v-if="tab === 0">
      <v-row>
        <v-col lg="9" xl="8">
          <v-card>
            <v-container class="mt-2 mb-4 py-4">
              <v-row>
                <v-toolbar flat>
                  <v-toolbar-title>
                    {{ $t("fav.yourRuleFav") }}
                  </v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                  <v-row justify="end">
                    <v-btn
                      class="mx-4"
                      depressed
                      color="secondary"
                      :disabled="!import_Default_Rules_Fav"
                      @click="POPresetFav = true"
                    >
                      {{ $t("fav.resetFav") }}
                    </v-btn>
                    <div>
                      <v-btn
                        class="mx-4"
                        depressed
                        color="primary"
                        :disabled="!need_save_rules"
                        @click="save"
                      >
                        {{ $t("generic.Save") }}
                      </v-btn>
                    </div>
                  </v-row>
                </v-toolbar>
              </v-row>
              <v-row>
                <rules-tree :type="'fav'"></rules-tree>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <!-- ------ -->

    <!-- Substances -->
    <div v-else>
      <v-container fluid class="mt-2 mb-4 py-4">
        <v-row>
          <v-col lg="9" xl="8">
            <table-sub-fav
              :substances="substances"
              v-on:updateFav="updateFav()"
            ></table-sub-fav>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- ------- -->

    <!-- Pop Up de sauvegarde -->
    <v-dialog v-model="save_before_quite" max-width="600">
      <v-card>
        <v-container>
          <v-row justify="center">
            <v-col cols="12">
              <p class="text-center text-h5">
                <v-icon color="primary">mdi-exclamation-thick</v-icon>
                {{ $t("generic.Warning") }}
                <v-icon color="primary">mdi-exclamation-thick</v-icon>
              </p>
              <p class="text-center text-body-1">
                {{ $t("fav.forgotToSaveAlert") }}
              </p>
              <v-divider></v-divider>
              <v-row align="center" justify="center" class="my-4">
                <v-col>
                  <v-row class="mb-4" align="center" justify="center">
                    <v-btn class="mx-4" color="primary" @click="quitWithSave">
                      {{ $t("generic.Save") }}
                    </v-btn>
                  </v-row>
                  <v-row align="center" justify="center">
                    <v-btn
                      class="mx-4"
                      color="primary"
                      text
                      @click="quitWithOutSave"
                      small
                    >
                      {{ $t("fav.quitWithOutSave") }}
                    </v-btn>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- Pop Up de reset fav -->
    <v-dialog v-model="POPresetFav" max-width="600">
      <v-card>
        <v-container>
          <v-row justify="center">
            <v-col cols="12">
              <p class="text-center text-h5">
                <v-icon color="primary">mdi-exclamation-thick</v-icon>
                {{ $t("fav.resetFavAlert") }}
                <v-icon color="primary">mdi-exclamation-thick</v-icon>
              </p>
              <p class="text-center text-body-1">
                {{ $t("fav.resetFavDescription") }}
                {{ this.identity.company }}
              </p>
              <v-divider></v-divider>
              <v-row justify="center" class="my-4">
                <v-col>
                  <v-row class="mb-4" align="center" justify="center">
                    <v-btn
                      class="mx-4"
                      color="primary"
                      @click="setDefaultFav()"
                    >
                      {{ $t("fav.resetFav") }}
                    </v-btn>
                  </v-row>
                  <v-row align="center" justify="center">
                    <v-btn
                      class="mx-4"
                      color="primary"
                      text
                      @click="cancelResetFav()"
                      small
                    >
                      {{ $t("generic.cancel") }}
                    </v-btn>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import TableSubFav from "../components/TableSubFav.vue";
import RulesTree from "../components/RulesTree.vue";
import { monitore } from "../components/helpers/helpers";

export default {
  data() {
    return {
      tab: null,
      save_before_quite: false,
      POPresetFav: false,
      tmp_router: "",
      dontQuit: true,
      substances: [],
      items: [],
      actives: [],
      defaultFav: [],
    };
  },
  components: {
    TableSubFav,
    RulesTree,
  },
  computed: {
    ...mapGetters([
      "need_save_rules",
      "identity",
      "current_rules_fav",
      "import_Default_Rules_Fav",
      "currentPage",
    ]),
  },
  beforeMount() {
    this.getSubstancesFav();
    if (this.$route.params.tab === 1) {
      this.tab = this.$route.params.tab;
    }
    if (this.currentPage.name === this.$route.name) {
      this.tab = this.currentPage.params.tab;
    }
    this.fetchDefaultFav();
  },
  methods: {
    ...mapMutations([
      "saveRulesFav",
      "setFavoritesRules",
      "setCurrentPage",
      "setimportDefaultRulesFav",
    ]),
    ...mapActions(["updateProfile"]),

    // fetch data from BDD
    async getSubstancesFav() {
      // console.log("GO TAKE FAV !!!!");
      try {
        // search user
        let url = "substancesfav?user_id=" + this.identity.id;
        const headers = {
          "content-type": "application/json",
        };
        const response = await this.axios.get(url, headers);
        // console.log("This is the response :", response);
        if (response.data.length) {
          // console.log("RESPONSE", response.data);
          this.substances = response.data;
        }
      } catch (err) {
        console.log(`err`, err);
        console.error(err);
      }
    },
    async updateFav() {
      // console.log("GO TAKE FAV !!!!");
      try {
        await this.getSubstancesFav();
        this.setCurrentPage({
          name: this.$route.name,
          params: { tab: 1 },
        });
        this.$router.go();
      } catch (err) {
        console.log(`err`, err);
        console.error(err);
      }
    },

    quitWithOutSave() {
      this.dontQuit = false;
      this.$store.commit("setNeedSaveRules", false);
      this.$router.push(this.tmp_router).catch(() => {});
    },
    async quitWithSave() {
      this.dontQuit = false;
      this.saveRulesFav(this.current_rules_fav);
      monitore("edit rules fav");
      await this.updateProfile();
      this.$store.commit("setNeedSaveRules", false);
      this.$router.push(this.tmp_router).catch(() => {});
    },
    async save() {
      this.saveRulesFav(this.current_rules_fav);
      monitore("edit rules fav");
      await this.updateProfile();
    },

    cancelResetFav() {
      this.POPresetFav = false;
    },

    // Default rules Fav
    async fetchDefaultFav() {
      // console.log("GO TAKE FAV !!!!");
      try {
        // search user
        let url = "defaultrulesfav?company=" + this.identity.company;
        url = encodeURI(url);
        // console.log(url);
        const headers = {
          "content-type": "application/json",
        };
        const response = await this.axios.get(url, headers);
        this.defaultFav = response.data;
        this.$store.commit("setimportDefaultRulesFav", false);
      } catch (err) {
        console.log(`err`, err);
        console.error(err);
      }
    },
    async setDefaultFav() {
      this.saveRulesFav(this.defaultFav);
      monitore("Set default Rules");
      await this.updateProfile();
      this.setCurrentPage({
        name: this.$route.name,
        params: { tab: 0 },
      });
      this.$router.go(); //refresh the page
    },
    resetrulesFav() {
      this.fetchDefaultFav();
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.dontQuit) {
      if (this.need_save_rules) {
        this.save_before_quite = true;
        this.tmp_router = to;
      } else {
        next();
      }
    } else {
      next();
    }
  },
};
</script>